export default "__VITE_ASSET__BdqkgOtG__"